import { render, staticRenderFns } from "./BookResources.vue?vue&type=template&id=3f926060&scoped=true&"
import script from "./BookResources.vue?vue&type=script&lang=js&"
export * from "./BookResources.vue?vue&type=script&lang=js&"
import style0 from "./BookResources.vue?vue&type=style&index=0&id=3f926060&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f926060",
  null
  
)

export default component.exports